<div class="table-container">
    <mat-table [dataSource]="filteredDictionary | keyvalue : noSort" style="width: 100%">
        <ng-container matColumnDef="parameter">
            <mat-header-cell *matHeaderCellDef> Parameter</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.value }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef> Value</mat-header-cell>
            <mat-cell *matCellDef="let element" title="{{getValue(element.key)}}"> {{ getValue(element.key)
                }}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsToDisplay"></mat-row>
    </mat-table>
</div>